module.exports = __webpack_public_path__ + "img/Warning.3b052d6c.svg";